export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M18.132 6.401a1 1 0 0 1 .832 1.555l-6.132 9.197a1 1 0 0 1-1.664 0L5.036 7.956a1 1 0 0 1 .832-1.555h12.264Z"/>
</svg>
`;
